export enum FontSize {
    "_14" = "0.875rem",
    "_16" = "1rem",
    "_18" = "1.125rem",
}
